// import React, { useState } from 'react';
// import InnerSidebar from './InnerSidebar/InnerSidebar';
// import "./SubSidebar.scss";
// import DetailsModule from '../../../dca-modules/crud/Details';
// import AppTokens from '../AppToken/AppToken';


// const SubSidebar = (props:any) => {
  

//   const [selectedComponent, setSelectedComponent] = useState<string>('general');

//   const renderComponent = () => {
//     switch (selectedComponent) {
//       case 'general':
//         return <DetailsModule
//         module={props.module}
//         primary_key={props.primary_key}
//       />;
//       case 'appTokens':
//         return <AppTokens
//         module={props.module}
//         primary_key={props.primary_key}
//          />;
//       default:
//         return <DetailsModule
//         module={props.module}
//         primary_key={props.primary_key}
//       />;
//     }
//   };

//   return (
//     <div className="app-container">
//       <InnerSidebar onSelect={setSelectedComponent} />
//       <div className="right-side-content">{renderComponent()}</div>
//     </div>
//   );
// };

// export default SubSidebar;
// function useParams(): { id: any; } {
//   throw new Error('Function not implemented.');
// }

import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import InnerSidebar from './InnerSidebar/InnerSidebar';
import "./SubSidebar.scss";
import DetailsModule from '../../../dca-modules/crud/Details';
import AppTokens from '../AppToken/AppToken';

const SubSidebar = (props: any) => {
  const [selectedComponent, setSelectedComponent] = useState<string>('general');
  const { id } = useParams(); // Fetches the `id` from the route parameters
  console.log("nnn", id)

  
  const renderComponent = () => {
    switch (selectedComponent) {
      case 'general':
        return (
          <DetailsModule
            module={props.module}
            primary_key={props.primary_key}
          />
        );
      case 'appTokens':
        return (
          <AppTokens
            module={props.module}
            primary_key={props.primary_key}
            primary_key_value={id}
          />
        );
      default:
        return (
          <DetailsModule
            module={props.module}
            primary_key={props.primary_key}
          />
        );
    }
  };

  return (
    <div className="app-container">
      <InnerSidebar onSelect={setSelectedComponent} />
      <div className="right-side-content">{renderComponent()}</div>
    </div>
  );
};

export default SubSidebar;
